let __ = (x) => { return x };

export { __ };
